import { useNavigate, useParams } from 'react-router-dom';

import { DEFAULT_FILTER_SEARCH_PARAM } from '@/components/tables/FilterableTable/FilterableTable';
import { EntityDetailsAwareRoute } from '@/modules/entities/contexts/entityDetails/EntityDetailsAwareRoute';
import {
  FilterOptions,
  NEW_ENTITY_ID,
} from '@/modules/entities/entities.constants';
import { GratDesignerStages, ROUTE_KEYS } from '@/navigation/constants';
import { getCompletePathFromRouteKey } from '@/navigation/navigationUtils';

import { GRATDesigner } from './GRATDesigner/GRATDesigner';
import { TAB_NAMES } from './GRATDesigner/StructuringDesigner/constants';

function isValidDesignerStage(
  possibleDesignerStage?: string
): possibleDesignerStage is GratDesignerStages {
  // this is a hack, but we have to cast possibleStrategyType as StrategyType
  // for the lookup on the StrategyTypes object to function the way that we want.
  // ultimately, this function is responsible for guaranteeing that a string is, in fact,
  // a valid strategy type
  if (!possibleDesignerStage) return false;
  return Object.values(GratDesignerStages).includes(
    possibleDesignerStage as GratDesignerStages
  );
}

export function DesignerPageV2() {
  const {
    entityType: _possibleEntityType,
    entityId,
    householdId,
    designerStage: possibleDesignerStage,
  } = useParams<{
    entityType: string;
    entityId: string;
    householdId: string;
    designerStage: string;
  }>();
  const navigate = useNavigate();

  if (!isValidDesignerStage(possibleDesignerStage)) {
    throw new Error(`Unknown design stage: ${possibleDesignerStage}`);
  }
  // reassigning because we're now confident that it's a design stage
  const designerStage = possibleDesignerStage;

  // TODO: this should be either a UUID or the string "new" -- nothing else is valid.
  if (!entityId) {
    throw new Error(
      `Unrecognized entityId is not a uuid or "${NEW_ENTITY_ID}".`
    );
  }

  if (!householdId) {
    throw new Error(`No householdId provided.`);
  }

  return (
    <EntityDetailsAwareRoute entityId={entityId}>
      <GRATDesigner
        initialStructuringTab={TAB_NAMES.ASSETS}
        designerStage={designerStage}
        entityId={entityId}
        householdId={householdId}
        onDelete={() => {
          const targetRoute = ROUTE_KEYS.HOUSEHOLD_ESTATE_TRUSTS;

          navigate(
            getCompletePathFromRouteKey(
              targetRoute,
              { householdId },
              {
                [DEFAULT_FILTER_SEARCH_PARAM]: FilterOptions.DRAFTS,
              }
            )
          );
        }}
      />
    </EntityDetailsAwareRoute>
  );
}
